var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxHomeAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22H19.5C20.0304 22 20.5391 21.7893 20.9142 21.4142C21.2893 21.0391 21.5 20.5304 21.5 20V11C21.5008 10.8684 21.4755 10.7379 21.4258 10.6161C21.376 10.4943 21.3027 10.3834 21.21 10.29L13.21 2.29C13.0226 2.10375 12.7692 1.99921 12.505 1.99921C12.2408 1.99921 11.9874 2.10375 11.8 2.29L3.8 10.29C3.70551 10.3826 3.63034 10.4931 3.57885 10.6149C3.52735 10.7368 3.50055 10.8677 3.5 11V20C3.5 20.5304 3.71071 21.0391 4.08579 21.4142C4.46086 21.7893 4.96957 22 5.5 22ZM10.5 20V15H14.5V20H10.5ZM5.5 11.41L12.5 4.41L19.5 11.41V20H16.5V15C16.5 14.4696 16.2893 13.9609 15.9142 13.5858C15.5391 13.2107 15.0304 13 14.5 13H10.5C9.96957 13 9.46086 13.2107 9.08579 13.5858C8.71071 13.9609 8.5 14.4696 8.5 15V20H5.5V11.41Z",
    fill: "url(#paint0_linear_199_1903)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_1903",
    x1: 12.5,
    y1: 1.99921,
    x2: 12.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94D40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1C2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxHomeAlt);
export default __webpack_public_path__ + "static/media/bx_bx-home-alt.d81d075463574356a88320d367f4d32d.svg";
export { ForwardRef as ReactComponent };